"use strict";

const Vue = window.Vue;
const readPageData = require('./page-data');
const RegisterApp = require('./pages/RegisterApp.vue').default || require('./pages/RegisterApp.vue');

new Vue({
    render: function(createElement) {
        return createElement(RegisterApp, {
            props: {
                initialData: readPageData('register-data')
            }
        });
    }
}).$mount('#register-app');



// WEBPACK FOOTER //
// ./resources/assets/js/register.js